import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Avb, Index } from '../../../../share/model/atomic-model';
import { OIV_BASE_URL } from '../../../../util/constant/common';

@Injectable({
    providedIn: 'root',
})
export class OivViewerService {
    #http = inject(HttpClient);
    #baseUrl = `${OIV_BASE_URL}`;

    getXml(urlName: string, language: string, isApprovalMode: boolean) {
        const params = new HttpParams({
            fromObject: {
                urlName,
                language,
            },
        });
        if (isApprovalMode) {
            return this.#http.get<Avb>(`${this.#baseUrl}/xml/retrieve/approval`, { params });
        }
        return this.#http.get<Avb>(`${this.#baseUrl}/xml/retrieve`, { params });
    }

    getIndices(textReference: string, language: string, assetType: string, contentVersion: string) {
        const params = new HttpParams({
            fromObject: {
                language,
                textReference,
                assetType,
                contentVersion,
            },
        });
        return this.#http.get<Index>(`${this.#baseUrl}/xml/indices/info`, { params });
    }
}
